import React from "react";
import LmsTable from "../ui/LmsTable";
import { useParseRouteActions, useFetchData } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";

const MainTable = () => {
  return (
    <LmsTable
      actionButtons={["edit", "export"]}
      apiSuffix="/draws/loan-phase2-proposals"
      columnLabelsDictionary={{
        loanNumber: "Loan #",
        borrowerOrganization: "Borrower",
        applicationNumber: "Application #",
      }}
      columnClickOptions={{
        applicationNumber: {
          idProp: "id",
          path: "servicing-btb-loans-for-approval/edit/{id}",
        },
      }}
    />
  );
};

const EditForm = ({ id }) => {
  const recordSuffix = `/loandetails/servicing/${id}`;
  const [{ data = {}, isLoading, error }] = useFetchData(recordSuffix);

  const myForm = new BCFormController(data, {
    isCompact: true,
    submitMethod: "PUT",
    clearSuffixesOnSubmit: [recordSuffix],
    submitSuffix: "/loans/bridge-to-build-loans-p2-aproval",
    initIsDisabled: !!data.btbp2analystRecommendationBtbphase2DecisionId,
    dataFormatterFunc: (data) =>
      "btbp2revisedIrr" in data
        ? Object.assign(data, { btbp2revisedIrr: parseFloat(data.btbp2revisedIrr) })
        : data,
  });

  myForm.addGroupFields(
    [
      myForm.getDisplayField("Borrower", {
        name: "borrowerOrganizationDisplay",
        noBackground: true,
        width: 3,
      }),
      myForm.getDisplayField("Loan #", {
        name: "loanNumberDisplay",
        noBackground: true,
        width: 4,
      }),
      myForm.getDisplayField("Project Name", {
        name: "loanName",
        noBackground: true,
        width: 3,
      }),
      myForm.getDisplayField("Property", { name: "street", noBackground: true, width: 2 }),
      myForm.getDisplayField("City", { name: "cityName", noBackground: true, width: 2 }),
      myForm.getDisplayField("State", { name: "stateName", noBackground: true, width: 2 }),
    ],
    { widths: 16 }
  );

  myForm.addGroupFields([
    myForm.getTextareaField("BTBP2 LRC Revision", {
      required: true,
      name: "btbp2lrcrevision",
    }),
    myForm.getTextareaField("BTBP2 Narrative", {
      required: true,
      name: "btbp2narrative",
    }),
  ]);

  myForm.addGroupFields([
    myForm.getInputField("BTBP2 Revised IRR", {
      required: true,
      name: "btbp2revisedIrr",
      onChange: ({ e, data, handleChange }) => {
        if (/^\d{0,3}(\.\d{0,2})?$/.test(data.value)) {
          handleChange(e, data);
        }
      },
    }),
    myForm.getDropdownField(
      "BTBP2 Analyst Recommendation BTB Phase2 Decision",
      "/draws/list-btb-phase2-decisions",
      {
        name: "btbp2analystRecommendationBtbphase2DecisionId",
      }
    ),
  ]);

  return (
    <LmsFormGenerator
      error={error}
      myForm={myForm}
      isLoading={isLoading}
      actions={["save", "save-close", "close"]}
    />
  );
};

const LmsServicingBTBLoansForApproval = ({ params = {}, history }) => {
  const { isMainPage, isEdit, isActionAllowed, id } = useParseRouteActions(params);

  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <React.Fragment>
      {isMainPage && <MainTable />}
      {isEdit && <EditForm id={id} />}
    </React.Fragment>
  );
};

export default LmsServicingBTBLoansForApproval;
